export const productKey = {
  StrykeWethHoneyVault: 'stryke-weth-honey-vault',
  StrykeWbtcHoneyVault: 'stryke-wbtc-honey-vault',
  StrykeBeraHoneyVault: 'stryke-bera-honey-vault',
} as const

export type ProductKey = typeof productKey[keyof typeof productKey]
